import styled from "styled-components";
import { Checkbox } from "antd";

export const CheckboxGroup = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  margin: 0px 0px 8px;
  line-height: 2em;
`;

export const CustomCheckbox = styled(Checkbox)`
  margin-bottom: 6px;
  margin-top: 6px;
  color: #707070;
  & .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin: 0;
  }

  & .ant-checkbox-wrapper {
    display: flex;
  }

  & .ant-checkbox {
    margin-top: 0px;
    margin-right: 8px;
    width: 22px;
    height: 22px;
  }

  & .ant-checkbox .ant-checkbox-input + .ant-checkbox-inner {
    width: 22px;
    height: 22px;
  }

  & .ant-checkbox-inner::after {
    left: 30%;
  }

  & span {
    padding: 0px;
  }

  & span:not(.ant-checkbox) {
    font-size: 16px;
  }

  & .ant-checkbox-disabled .ant-checkbox-inner {
    width: 25px;
    height: 25px;
    background-color: gray;
    border-color: gray;
  }

  & .ant-checkbox-checked .ant-checkbox-inner {
    width: 25px;
    height: 25px;
    background-color: #cde6ff;
    border: solid #1070b6 2px;
  }

  & .ant-checkbox-checked .ant-checkbox-inner::after {
    border: 3px solid #1070b6;
    border-top: 0;
    border-left: 0;
    transform: rotate(45deg) scale(1.2) translate(-50%, -50%);
  }
`;
